import {ContentBox} from '@hconnect/common/components'
import {Typography, Stack} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type EditTaskCardProps = {
  title: string
  children?: React.ReactNode
}

export const EditTaskCard: React.FC<EditTaskCardProps> = (props) => {
  const {title, children} = props
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <ContentBox
      data-test-id="task-details"
      mode="max100PercentOfParentHeight"
      bodyWithPadding
      title={
        <Typography
          component="span"
          variant="h2"
          sx={{textTransform: 'none'}}
          data-test-id="task-details-title"
          display="flex"
          alignItems="center"
        >
          {t('task.action.edit')} {title}
        </Typography>
      }
      headerSx={{paddingBottom: 0}}
    >
      <Stack spacing={2} useFlexGap>
        {children}
      </Stack>
    </ContentBox>
  )
}
